(function(window, document, undefined) {

  'use strict';

  document.querySelectorAll('[data-quick-search]').forEach(function(element) {
    search(element);
  });

  document.addEventListener('input', function(event) {
    search(event.target);
  });

  /**
   * Search inside element. P tags followed by UL, LI tags.
   *
   * @param Element element
   */
  function search(element)
  {
    if (!element.hasAttribute('data-quick-search')) {
      return;
    }

    const keywords = element.value;
    const target = document.getElementById(element.dataset.quickSearch);
    const lists = target.querySelectorAll('ul');

    if (!keywords || keywords == '') {
      lists.forEach(function(element) {
        element.previousElementSibling.style.display = 'block';
        element.classList.remove('in');
        let options = element.querySelectorAll('li');

        options.forEach(function(element) {
          element.style.display = 'list-item';
        });
      });

      return;
    }

    const regex = new RegExp(`.*${keywords}.*`, 'i');

    lists.forEach(function(element) {
      let options = element.querySelectorAll('li');
      let has_results = false;

      options.forEach(function(element) {
        if (!regex.test(element.innerHTML)) {
          element.style.display = 'none';
        } else {
          element.style.display = 'list-item';
          has_results = true;
        }

      });

      if (has_results) {
        element.previousElementSibling.style.display = 'block';
        element.classList.add('in');
      } else {
        element.previousElementSibling.style.display = 'none';
        element.classList.remove('in');
      }
    });

  }

  document.addEventListener('click', function(event) {
    if (!event.target.hasAttribute('data-quick-search-reset')) {
      return;
    }

    const quick_search_input = event.target.parentElement.querySelector('[data-quick-search]');
    quick_search_input.value = '';
    quick_search_input.dispatchEvent(new Event('input', {
      'bubbles': true,
      'cancelable': true
    }));
  });

})(window, document, undefined);
